import { LevelType } from './Progress/PlayerLevels';
import { WorldDataHelper } from '../../Utility/WorldDataHelper';
import { IPlayerState } from './IPlayerState';
import { Immutable } from '../../Utility/Types';
/**
 * Get the total number of stars earned by the player.
 * @param state
 */
export function getLevelStarsTotal(state: Immutable<IPlayerState>): number {
    return state.levels[LevelType.Core].reduce(
        (a, b) => (b.stars != null ? a + b.stars : a),
        0
    );
}

export function getCurrentLevelNumber(
    playerState: Immutable<IPlayerState>
): number {
    return Math.min(
        getHighestLevelCompleted(playerState) + 1,
        WorldDataHelper.maxLevel(playerState.maxWorld)
    );
}

export function getHighestLevelCompleted(
    playerState: Immutable<IPlayerState>,
    levelType: LevelType = LevelType.Core
): number {
    return playerState.levels[levelType].reduce(
        (acc, level) => {
            if (level.stars > 0) return Math.max(acc, level.levelNumber);
            return acc;
        },
        0
    );
}
